import React from 'react';
import './styles.css';
import { Col, Row, Popover } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleDown } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import {
  ActivationSociogramModal,
  BupSpinner,
  DividerContainer,
  ItemList,
} from '@BUP/components';
import ConoceInstrumentos from '@BUP/assets/Images/Data/data_(1)_conoce-instrumentos.png';
import RespondeDiagnostico from '@BUP/assets/Images/Data/data_(3)_responde-diagnostico.png';
import ApoyaEstudiantes from '@BUP/assets/Images/Data/data_(2)_activa-instrumentos.png';
import ActivaSociograma from '@BUP/assets/Images/Data/data_sociograma.png';
import GuiaOrientacion from '@BUP/assets/Documents/Data/guia_orientacion_toma_de_datos.pdf';
import ImageData from '@BUP/assets/Images/Data/data-18.png';
import {
  useAuth,
  useGetSurveysSociogram,
  useSendActivationSurvey,
} from '@BUP/hooks';
import { useTranslation } from 'react-i18next';
import i18n from '../../../configs/i18n';

const DataTeacherPage = () => {
  const { user } = useAuth();
  const [t] = useTranslation();
  const language = i18n?.language;

  const { isLoadingSurveySociogram, surveySociogram } = useGetSurveysSociogram(
    user
  );
  const isDoneSurveySociogram = !!(
    !surveySociogram?.isActive && surveySociogram?.isDone
  );

  const {
    updateSurveySociogram,
    dataResponseSurvey,
    errorResponseSurvey,
  } = useSendActivationSurvey(surveySociogram);

  const handleCloseSurveySociogram = async () => {
    await updateSurveySociogram({
      data: {
        isDone: true,
        isActive: false,
      },
    });
    // setIsModalVisible(false);
  };

  const contentStep3 = (
    <div>
      <p>{t('pages.data.textPopover')}</p>
    </div>
  );
  return (
    <>
      <DividerContainer title="BRAVE UP! DATA" />
      {isLoadingSurveySociogram ? (
        <BupSpinner size="large" />
      ) : (
        <>
          <p className="welcome-paragraph">
            {t('pages.data.welcomeTextTeacher')}
          </p>
          <ItemList
            className="item-list"
            count="1"
            src={ConoceInstrumentos}
            title={
              <Link to="data/instruments">{t('pages.data.title1Teacher')}</Link>
            }
            description={t('pages.data.description1Teacher')}
            url={
              <Link className="itemList-link" to="data/instruments">
                {t('pages.data.linkTextHere')}
              </Link>
            }
            urlLink="data/instruments"
          />
          <ItemList
            count="2"
            src={RespondeDiagnostico}
            title={
              <Link className="itemList-link" to="data/confirm-survey">
                {t('pages.data.title2Teacher')}
              </Link>
            }
            description={t('pages.data.description2Teacher')}
            url={
              <Link className="itemList-link" to="data/confirm-survey">
                {t('pages.data.linkTextHere')}
              </Link>
            }
          />
          <ItemList
            count="3"
            src={ApoyaEstudiantes}
            title={t('pages.data.title3Teacher')}
            description={t('pages.data.desccription3Teacher')}
            download={
              <Popover content={contentStep3}>
                <a
                  target="_blank"
                  href={language === 'es' ? GuiaOrientacion : '/'}
                  rel="noreferrer"
                >
                  <FontAwesomeIcon
                    className="download-icon"
                    icon={faArrowCircleDown}
                  />
                </a>
              </Popover>
            }
          />
          {!isDoneSurveySociogram ? (
            <ItemList
              count="4"
              src={ActivaSociograma}
              title={
                surveySociogram?.isActive ? (
                  t('pages.data.sociogramTeacherFinishTitle')
                ) : (
                  <Link className="itemList-link" to="data/active-sociogram">
                    {t('pages.data.sociogramTeacherTitle')}
                  </Link>
                )
              }
              description={
                surveySociogram?.isActive && !surveySociogram?.isDone
                  ? t('pages.data.sociogramMessageActivated')
                  : dataResponseSurvey || surveySociogram?.isDone
                  ? ''
                  : t('pages.data.sociogramTeacherDescription')
              }
              url={
                !surveySociogram?.isActive ? (
                  <Link className="itemList-link" to="data/active-sociogram">
                    {t('pages.data.linkTextHere')}
                  </Link>
                ) : null
              }
              isActiveSociogram={surveySociogram?.isActive}
              isDoneSurveySociogram={isDoneSurveySociogram}
              onClick={handleCloseSurveySociogram}
              textButton="Cerrar sociograma"
              buttonModal={
                <ActivationSociogramModal
                  modalTitle={t(
                    'pages.data.sociogram.finishSociogramModal.modalTitle'
                  )}
                  modalButton1={t(
                    'pages.data.sociogram.finishSociogramModal.modalButton1'
                  )}
                  modalButton2={t(
                    'pages.data.sociogram.finishSociogramModal.modalButton2'
                  )}
                  modalBody={t(
                    'pages.data.sociogram.finishSociogramModal.modalBody'
                  )}
                  buttonModalText={t(
                    'pages.data.sociogram.finishSociogramModal.buttonModalText'
                  )}
                  messageSuccess={t(
                    'pages.data.sociogram.finishSociogramModal.messageSuccess'
                  )}
                  dataResponse={dataResponseSurvey?.id}
                  errorResponse={errorResponseSurvey}
                  errorResponseMessage={errorResponseSurvey?.message}
                  handleClickSociogram={handleCloseSurveySociogram}
                  closable
                />
              }
            />
          ) : null}
          <Row justify="end">
            <Col className="gutter-row" span={12}>
              <img style={{ width: '100%' }} src={ImageData} alt="" />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default DataTeacherPage;
